<template>
    <div class="preview-wrap">
        <div class="preview-body">
            <div class="grid-container pad-top--large">
                <div class="grid-x grid-padding-x">
                    <div class="cell small-12">
                        <h2 class="text-center text-white h1 text-caps">Preview all</h2>
                    </div>
                </div>
                <div class="grid-x grid-padding-x">
                    <div
                        class="cell small-6 medium-3 large-2 text-center"
                        v-for="(item, index) in basketItems"
                        v-bind:key="index"
                        v-if="item.design_id > 0">
                        <app-preview-design v-bind:itemNo="index" v-bind:designId="item.design_id" />
                    </div>
                </div>
                <div class="grid-x grid-padding-x">
                    <div class="cell small-12 text-center">
                        <span
                            v-on:click="goToCheckout"
                            class="button light-blue squared text-caps">
                            Checkout now
                        </span>
                        &nbsp;
                        <button v-on:click="closeModal" class="button light-blue squared text-caps">
                            Close preview
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import previewDesign from '@/components/Order/PreviewSingle';

export default {
    name: 'PreviewAll',
    components: {
        appPreviewDesign: previewDesign,
    },
    computed: {
        basketItems() { return this.$store.getters.basketItems; },
    },
    methods: {
        goToCheckout() {
            this.$emit('checkoutFromPreview');
        },
        closeModal() {
            this.$emit('closePreviewAll');
        },
    },
};
</script>


// WEBPACK FOOTER //
// src/components/Order/PreviewAll.vue